import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function TableauIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <path fill="#7099A6" d="M9.682.924v.928H8.056v.604h1.626v1.85h.635v-1.85h1.668v-.604h-1.668V0h-.635v.924Z" />
      <path fill="#EB912C" d="M4.366 3.28v1.347H1.903v.845h2.463v2.736h.913V5.472h2.5v-.845h-2.5V1.933h-.913v1.346Z" />
      <path
        fill="#59879B"
        d="M14.684 3.28v1.347h-2.462v.887h2.462v2.694h.95V5.514h2.463v-.887h-2.463V1.933h-.95v1.346Z"
      />
      <path
        fill="#E8762C"
        d="M9.445 7.868v1.51h-2.74v1.124h2.74v3.019h1.109v-3.019h2.74V9.377h-2.74V6.36H9.445v1.51Z"
      />
      <path
        fill="#5B6591"
        d="M17.502 8.63v.948h-1.668v.765h1.668v1.891h.832v-1.891H20v-.765h-1.667V7.687h-.832v.943Z"
      />
      <path fill="#7099A6" d="M1.626 8.714v.905H0v.642h1.626v1.81h.637v-1.81l1.667-.06v-.582H2.263V7.81h-.637v.905Z" />
      <path
        fill="#C72035"
        d="M4.366 12.977v1.348H1.903v.887h2.463v2.694h.95v-2.694h2.462v-.887H5.316v-2.694h-.95v1.346Z"
      />
      <path
        fill="#1F447E"
        d="M14.684 12.977v1.348h-2.462v.846h2.462v2.735h.95v-2.735h2.463v-.846h-2.463v-2.694h-.95v1.346Z"
      />
      <path fill="#5B6591" d="M9.606 16.4v.943H7.938v.767h1.668V20h.831v-1.89h1.667v-.767h-1.667v-1.89h-.831v.947Z" />
    </Icon>
  );
}
